import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { PriceList, Organization, Client } from '../../shared/sdk';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable, Subject, of } from 'rxjs';
import { OrganizationService } from '../../organizations/organization.service';
import { PriceListService } from '../price-list.service';
import {
  debounceTime,
  filter,
  switchMap,
  takeUntil,
  map,
  catchError,
} from 'rxjs/operators';
import { ClientService } from '../../clients/client.service';
import {
  NgbTypeaheadSelectItemEvent,
  NgbActiveModal,
} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-price-list-add',
  templateUrl: './price-list-add.component.html',
  styleUrls: ['./price-list-add.component.css'],
})
export class PriceListAddComponent implements OnInit {
  @Input() priceList: PriceList;
  @ViewChild('priceListName', { static: true }) priceListName: ElementRef;
  loading: any = {};
  priceListForm: FormGroup;
  sent: boolean;
  private activeOrg: Organization;
  private onDestroy$: Subject<void> = new Subject();

  constructor(
    private activeModal: NgbActiveModal,
    private orgService: OrganizationService,
    private priceListService: PriceListService,
    private clientService: ClientService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.priceListForm = this.fb.group({
      name: ['', Validators.required],
      clientSearch: [''],
      clientId: [''],
      custom: [],
    });

    if (!this.priceList) {
      this.priceList = new PriceList();
    } else {
      this.priceList = new PriceList(this.priceList);
      this.priceListForm.patchValue(this.priceList);
    }

    this.orgService.active
      .pipe(
        filter((org) => !!org),
        takeUntil(this.onDestroy$)
      )
      .subscribe((org: Organization) => {
        this.activeOrg = org;
      });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => this.priceListName.nativeElement.focus(), 100);
  }

  clientSearch = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      filter((term) => term.length > 0),
      switchMap((term: string) => {
        this.loading.clients = true;
        return this.clientService
          .find(this.activeOrg.id, term)
          .pipe(catchError((_) => of([])));
      }),
      map((clients: Client[]) => {
        this.loading.clients = false;
        return clients;
      }),
      takeUntil(this.onDestroy$),
    );

  onClose() {
    this.activeModal.dismiss();
  }

  onSave() {
    this.sent = true;

    if (this.priceListForm.valid) {
      const priceListFormValue = this.priceListForm.value;
      const editing = !!this.priceList.id;

      this.priceListService[!editing ? 'create' : 'patch'](
        !editing ? this.activeOrg.id : this.priceList.id,
        priceListFormValue,
      ).subscribe((priceList) => {
        this.activeModal.close(priceList);
      });
    }
  }

  onSelectClient(match: NgbTypeaheadSelectItemEvent) {
    if (match && match.item) {
      const client = match.item as Client;
      this.priceListForm.controls.clientId.patchValue(client.id);
      this.priceListForm.controls.clientSearch.patchValue(client.name);
      this.priceListForm.controls.clientSearch.disable();
      match.preventDefault();
    } else {
      this.priceListForm.controls.clientId.patchValue('');
      this.priceListForm.controls.clientSearch.patchValue('');
      this.priceListForm.controls.clientSearch.enable();
    }
  }
}
